



































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import * as api from "../data/api";
import Spinner from "@/components/Spinner.vue";
import { computed, onBeforeUnmount, onMounted } from "@vue/composition-api";
import { RiskyUsers } from "../data/model";
import RiskyUserRow from "./RiskyUserRow.vue";
import { UseCollection } from "@/common/composition/use-collection";
import { SharedState } from "@/common/state";
import { table_config } from "./table.config";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { emptyFn } from "@/fp";
import { EventBus } from "@/eventbus";
import {
  change_entity_familiarity_status,
  get_user_email_from_internal_entity_id,
} from "@/views/customize/in-motion/exposure-control/data/api";
import { POPULATION_TYPE } from "@/common/models";
import { ToastType, UseToast } from "@/components/root/toast/toast.state";
import RiskyUsersPolicyScriptModalVue from "../RiskyUsersPolicyScriptModal.vue";
import { AxisType, CoordinateInputTier3, TimeAxisType } from "@/gql/types";
import EventsModalVue from "@/components/modals/events-modal/EventsModal.vue";
import { EventsModalProps } from "@/components/modals/events-modal/model";
import ManageTrustModalVue from "../../../exposure-control/manage-trust-modal/ManageTrustModal.vue";

/* 
 TODO: 
 Shimry
 - - - - -
 THE ISSUE:
 the results for risky users list
 api call : https://qa-webapi.cognni.ai/extproxy/integrations/risky-users?
 doesn't contain the user email. just the name.
 and in the calls to https://qa-webapi.cognni.ai/extproxy/integrations/familiarity-aggregations?
 we need the email!
*/

export default Vue.extend({
  components: {
    Modal,
    Spinner,
    VirtualTable,
  },
  props: ["modalData"],
  setup(props, { root: { $router } }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "110rem",
      height: "60rem",
    };

    // @ts-ignore
    const limit = props.modalData.take || -1;

    const users = UseCollection<RiskyUsers, { cursor: string; l0_id: string }>(
      async ({ cursor, l0_id }) => {
        const res = await api.get_risky_users_for_l0({
          l0_id,
          cursor,
          date: SharedState.selectedTimeFrameOption.value.from,
          frame:
            SharedState.selectedTimeFrameOption.value.type == TimeAxisType.Month
              ? "Month"
              : "Week",
        });
        return res;
      }
    );

    const investigate_user = async (item: RiskyUsers) => {
      const user_email_res = await get_user_email_from_internal_entity_id(
        item.id
      );

      SharedState.investigation.investigate({
        name: item.name,
        email: user_email_res.success ? user_email_res.value : "",
        id: item.id,
        type: POPULATION_TYPE.EMPLOYEE,
      });
    };

    const manage_user_trust = async (item: RiskyUsers) => {
      const user_email_res = await get_user_email_from_internal_entity_id(
        item.id
      );
      if (user_email_res.success) {
        // @ts-ignore
        const info_type_id = props.modalData.id;
        await UseModal().show(ManageTrustModalVue, {
          entity: {
            ...item,
            email: user_email_res.value,
            type: POPULATION_TYPE.EMPLOYEE,
          },
          info_types: [info_type_id],
        });
      } else {
        UseToast().show({
          type: ToastType.ALERT,
          msg: "Something went wrong :(",
        });
      }
    };

    const show_events = async (item: RiskyUsers) => {
      // @ts-ignore
      const info_type_name = props.modalData.name;
      // @ts-ignore
      const info_type_id = props.modalData.id;
      await UseModal().show(EventsModalVue, {
        title: `<b>${item.name}</b> risky <b>${info_type_name}</b> information events`,
        events_only: true,
        hide_filters: ["severities"],
        coordinates: [
          {
            x: {
              type: AxisType.EmployeeSender,
              values: [item.id],
            },
            y: {
              type: AxisType.ContentLabel,
              values: [info_type_id],
            },
            z: {
              type: SharedState.selectedTimeFrameOption.value.type,
              values: [SharedState.selectedTimeFrameOption.value.from],
            },
          },
          {
            x: {
              type: AxisType.EmployeeSender,
              values: [item.id],
            },
            y: {
              type: AxisType.Severity,
              values: ["1", "2", "3"],
            },
            z: {
              type: SharedState.selectedTimeFrameOption.value.type,
              values: [SharedState.selectedTimeFrameOption.value.from],
            },
          },
        ] as CoordinateInputTier3[],
      } as EventsModalProps);
    };

    const show_playbook = (label_id: string, label_name: string) => {
      if (SharedState.is_biz_user.value) {
        SharedState.restrictions.show_restrictions_modal("role", "Playbooks");
        return;
      }
      UseModal().show(RiskyUsersPolicyScriptModalVue, {
        label_id,
        label_name,
      });
    };

    const subs = {
      inv: emptyFn(),
      show_events: emptyFn(),
      toggle_trusted: emptyFn(),
      manage_trust: emptyFn(),
    };
    onMounted(async () => {
      // @ts-ignore
      const l0_id = props.modalData.id;
      await users.load_items({ cursor: "", l0_id });
      subs.inv = EventBus.listen("investigate", investigate_user);
      subs.show_events = EventBus.listen("show_events", show_events);
      subs.manage_trust = EventBus.listen("manage_trust", manage_user_trust);
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      limit,
      config,
      RiskyUserRow,
      show_playbook,
      table_config,
      is_loading: users.is_loading,
      has_no_results: users.has_no_results,
      display_users: computed(() =>
        limit > -1 ? users.items.value.slice(0, limit) : users.items.value
      ),
      load_more_users: users.load_more_items,
    };
  },
});
